module.exports = __webpack_public_path__ + "static/media/legumes.93ee433b.jpg";